module.exports = __webpack_public_path__ + "static/Edward-Astle-98aae58d5d9576616468184c2be0847c.jpg";